export default __webpack_public_path__ + "static/media/illustrator.dad0ad29.png";